<template >
<div class="container-fluid_">

<div class="row">
<div class="col-6">
  <div class="card border-success">
    <div style="background-color:#0066FF" class="card-header bg-primary text-white">
      <h4><i style="color:#FFD700" class="fas fa-edit mr-3" aria-hidden="true"></i>NUOVO COUPON</h4>
    </div>  
  <div class="card-body">    
  <alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2 mb-2"  ></alert-box>
  <waitingModal v-if="waitModal.show == true" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingModal>
  <form v-on:submit.prevent="submit()">

    <legend style="color:blue" class="col-form-label ">TIPO COUPON</legend>
    <div class="form-check form-check-inline mb-3">
      <input @click="setCoupon(365)" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="'paid'" v-model="coupon.typeId" checked>
      <label class="form-check-label" for="inlineRadio1">GIFT CARD</label>
    </div>
    <div class="form-check form-check-inline mb-3">
      <input @click="setCoupon(7)" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" :value="'notPaid'" v-model="coupon.typeId">
      <label class="form-check-label" for="inlineRadio2">CASHBACK</label>
    </div>

  <div v-if="coupon.typeId == 'notPaid'" class="form-group mt-3">
    <!--<label for="formGroupExampleInput">Valore €</label>-->
    <div class="input-group col-md-6">
      <div class="input-group-prepend">
        <div style="background-color:rgb(0, 13, 128);color:white" class="input-group-text"><strong>VALORE €</strong></div>
      </div>  
      <input max="1000" required v-focus step="0.01" min="0.01" type="number" class="form-control" v-model="coupon.total" >      
    </div>
    
  </div>
  <div v-else>
        <h6  class="text-center" style="color:blue"><strong>Pagamento singolo o misto.</strong> </h6>
        <div  class="row mt-3 mb-3">
          
          <div class="input-group col-md-6">
              <div class="input-group-prepend">
                <div style="background-color:green;color:white" class="input-group-text"><strong>CONTANTE €</strong></div>
              </div>
          
              <input v-focus type="number" :min="coupon.elec > 0  ? 0 : 0.01" :required="coupon.elec == 0"  step="0.01" class="form-control" id="inlineFormInputGroup" placeholder="Inserire un importo oppure zero." v-model="coupon.cash">
              
          </div>
            <div class="input-group col-md-6">
              <div class="input-group-prepend">
                <div style="background-color:orange;color:black" class="input-group-text"><strong>ELETTRONICO €</strong></div>
              </div>
              <input type="number" step="0.01" :min="coupon.cash > 0 ? 0 : 0.01"  :required="coupon.cash == 0" class="form-control" id="inlineFormInputGroup" placeholder="Inserire un importo oppure zero." v-model="coupon.elec">
            </div>
        </div>
</div>



  <div class="form-group">
    <label for="formGroupExampleInput2">RIFERIMENTO</label>
    <input required type="text" class="form-control" v-model="coupon.reference"> 
        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput3">TELEFONO</label>
    <input required type="number" class="form-control" v-model="coupon.tel" >
        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput4">DATA SCADENZA</label>
    <input required type="date" class="form-control" v-model="coupon.expire_at">
        
  </div>

  <div class="form-group">
    <label for="formGroupExampleInput4">NOTE</label>
    <input type="text" class="form-control" v-model="coupon.note">        
  </div>


<!--
  <fieldset class="form-group row">
    <legend class="col-form-label col-sm-2 float-sm-left pt-0">Pagamento</legend>
    <div class="col-sm-10">
      <div class="form-check">
        <input @click="setCoupon(365)" class="form-check-input" type="radio" name="gridRadios1" id="gridRadios1" :value="'CASH'" v-model="coupon.typeId" checked>
        <label style="color:green" class="form-check-label" for="gridRadios1">
          CONTANTE
        </label>
      </div>
      
      <div class="form-check ">
        <input @click="setCoupon(365)" class="form-check-input" type="radio" name="gridRadios2" id="gridRadios2" :value="'ELEC'" v-model="coupon.typeId">
        <label style="color:#FF6600" class="form-check-label" for="gridRadios2">
          ELETTRONICO
        </label>
      </div>
     
      <div class="form-check mt-2">
        
        <input @click="setCoupon(7)" class="form-check-input" type="radio" name="gridRadios3" id="gridRadios3" :value="'RETURN'" v-model="coupon.typeId">
        <label style="color:brown" class="form-check-label" for="gridRadios3">
          NESSUNO
        
        </label>
      </div>
     
    </div>
  </fieldset>
-->


      <button @click="$emit('update')" type="button" class="btn btn-secondary mr-3">
        <i style ="color:yellow" class="fas fa-reply mr-3" aria-hidden="true"></i>
        RITORNA A LISTA COUPON
      </button>
      <button :disabled="spinner" type="submit" class="btn btn-primary float-right">
        <i  style="color:#FFCC00" class="fas fa-save mr-3" aria-hidden="true"></i>
         REGISTRA
         <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>
      
</form>
</div>
</div> 
    


</div>
</div>



</div>
</template>
<script>


import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue';
import { mapGetters }             from 'vuex';
import {eanCD,createEAN_COUPON}   from '@/functions'; 
import selfCash                   from '@/components/mixins/SelfCash.js' 
import waitingModal               from "@/components/common/WaitingModal.vue"  
import fmt                        from '@/components/mixins/fmt.js'        


export default {
  mixins:[selfCash,fmt],
  components: {alertBox,waitingModal},
  
 data () {
    return {
    

      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'REGISTRAZIONE IN CORSO ...',
        msg2       : 'CONTROLLARE LISTA COUPON.' 

      },  
    cash        : 0,
    coupon      : {typeId:'paid','cash':0.00,'elec':0.00},
    deskId      : 1,
    spinner     : false,
    
    
    //option    : 0,
    msg : {
        title : '',
        body  : '',
        type  : 0
      }


    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },
  computed: {
    ...mapGetters(['company','storeId']) 
  },
mounted()
{

 
    
},  
created()
{ 
  this.initCoupon()
  //this.storeSelfCashApi()
  
  
},
methods :{
closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
setCoupon(n)
{
  
  let date              = new Date()
  
  let expire_at         = date.setDate(date.getDate() + n)    
  let newDate           = new Date(expire_at).toISOString().slice(0, 10)
  this.coupon.expire_at = newDate

}, 
initCoupon()
{
  let date              = new Date()
  
  let expire_at         = date.setDate(date.getDate() + 365)    
  let newDate           = new Date(expire_at).toISOString().slice(0, 10)


  //this.coupon.typeId    = 'CASH'
  this.coupon.total     = 0
  this.coupon.cash      = 0.00
  this.coupon.elec      = 0.00
  this.coupon.reference = ''
  this.coupon.tel       = '' 
  this.coupon.typeId    = 'paid'
  this.coupon.expire_at = newDate
  this.coupon.deskId    = 1
  this.coupon.storeId   = this.storeId
  this.coupon.note      = ''
  let deskId            = JSON.parse(localStorage.getItem("deskId"))
    
    if(deskId)
    {    
      this.coupon.deskId = Number(deskId)
      this.deskId        = deskId
    }
    
    //console.log(this.deskId)
},
async submit()
{

  this.msg.title = ''

 
  if(this.coupon.typeId == 'paid')
  {
    
    const total = Number(this.coupon.cash) + Number(this.coupon.elec)
    this.coupon.total = total

  }

  this.msg.title   = ''
  const sp         = {'sp'   : 'spCreateCoupon'}
  const data       = {'data' : this.coupon }
    
  data.companyId = this.company.Id 
  const json       = Object.assign(data, sp)
  
  this.spinner = true
  this.waitModal.show  = true   
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              this.waitModal.sentinel = 1 
              const couponId = res.data.recordsets[0][0].couponId
              const barcode = createEAN_COUPON(couponId)
             
              const coupon = {'couponId':couponId,'barcode':barcode}
              if(this.coupon.typeId == 'paid' && this.coupon.cash > 0)
              {
                const cash = this.fmt1(this.coupon.cash).replace(',','')
                this.sendTotalToSelfCash(cash)
                
              }
              this.updateCoupon(coupon)
                             
                         
            }
           else if(res.status==500)
           {               
                this.waitModal.sentinel = 3  
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                this.waitModal.sentinel = 2                 
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
        
          }).catch(err => {
              
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},

async updateCoupon(coupon)
{
  
  this.msg.title = ''
  const sp    = {'sp' : 'spUpdateCoupon'}
  const data  = {'data' : coupon }
  const json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              //this.coupon = {}
              this.initCoupon()
            
              this.msg.title = 'REGISTRAZIONE COUPON EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
                 
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},


}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}
label,legend{
  font-weight: bold;
}
.form-check-label
{
  cursor: pointer;
}
</style>
